<template>
  <gg-card>
    <gg-card-header>
      Add Access Host
    </gg-card-header>
    <gg-card-text>
      <form>
        <gg-text-field name="Host"
                       label="Host"
                       v-model="host"
                       v-validate="'required'"
                       placeholder="% wildcard is allowed"
                       :error-messages="errors.collect('Host')"></gg-text-field>

      </form>
      <gg-btn dark
              @click="addHost"
              :loading="loading">Add Host</gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddAccessHostForm',
  data () {
    return {
      host: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      addMysqlAccessHost: 'mysql/addMysqlAccessHost',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async addHost () {
      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid) return

        this.loading = true
        await this.addMysqlAccessHost({ host: this.host, _username: this.$route.query.user })

        this.reportSuccess(`The host “${this.host}” was added to the access list.`)
        this.$emit('reload-table')
        this.reset()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    reset () {
      this.host = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    }
  },
}
</script>
